<template>
    <div style="position: relative;height: 100%;overflow-y: auto" ref="app">
      <app-navbar></app-navbar>
      <transition name="fade" appear>
        <app-navbar2 v-show="showFlag"></app-navbar2>
      </transition>
      <app-header  ref="header"></app-header>
      <app-product></app-product>
      <app-footer></app-footer>
    </div>
</template>

<script>
  import AppNavbar from '../components/Navbar'
  import AppNavbar2 from '../components/Navbar2'
  import AppHeader from '../components/Header/carouselIndex'
  import AppProduct from '../components/Product'
  import AppBanner from '../components/Banner'
  import AppNotice from '../components/Notice'
  import AppFooter from '../components/Footer'

  export default {
    name: "index",
    data(){
      return{
        showFlag:false
      }

    },
    components:{
      AppNavbar,
      AppHeader,
      AppProduct,
      AppBanner,
      AppNotice,
      AppFooter,
      AppNavbar2,
    },
    mounted() {
      console.log(window);
      this.$refs.app.onscroll = ()=> {
        let domHeight = this.$refs.header.$el.clientHeight
        let scrollHeight = this.$refs.app.scrollTop
        if(scrollHeight > domHeight){
          this.showFlag = true
        }else{
          this.showFlag = false

        }

      }


    }


  }
</script>

<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }
  .fade-enter, .fade-leave-to  {
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// src/view/index.vue